import { User } from "@sentry/react";
import { IAccount } from "./account";
import { IMessage } from "./message";
import { IAttachment } from "./attachment";
import { IProduct } from "./product";

export enum OrderStatus {
    pending = "pending",
    submitted = 'submitted',
    ongoing = 'ongoing',
    completed = 'completed',
    canceled = 'canceled',
    sav = 'sav',
}

export interface Order {
    id: number;
    status: OrderStatus;
    products: IProduct[];
    payload?: string;
    account: IAccount;
    createdBy: User;
    attachments: IAttachment[];
    comments?: string;
    messages: IMessage[];
    serviceComments?: string;
    clientId?: string;
    clientDescription?: string;
    assignedUserId?: number;
    assignmentStatus?: "pending" | "assigned";
    serviceProviderId?: number;
    assignedGroupId?: number;
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date;
}